<div mat-dialog-content>
    <p>Are you sure you want to logout?</p>
</div>
<div mat-dialog-actions>
    <button mat-button class="button1" [mat-dialog-close]="false" cdkFocusInitial>Cancel</button>
    <button mat-button class="button1 ml-auto" (click)="yes()">Yes</button>
</div>